import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FormControl, FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { ApiService } from '../services/api.service';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-devices',
  standalone: true,
  imports: [
    MatTableModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    MatGridListModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css'],
})
export class DevicesComponent implements OnInit {
  @Input() tabSelected: boolean = false;
  displayedColumnsForm = new FormControl('');

  displayedColumns: string[] = [
    'mac',
    'serialNumber',
    'model',
    'firmware',
    'group',
    'dateRegister',
    'dateLastRequest',
    'offline',
  ];
  groups = [];
  dataSource = new MatTableDataSource();
  selectedColumn: string = 'mac'; // Default column to filter by
  filterValue: string = '';
  currentPage = 1;
  offline = 0;
  offlineTotal = 0;

  private filterSubject = new Subject<[string, number]>();

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.apiService.getGroups(1, {}).subscribe((data) => {
      this.groups = data.map((group: { name: string }) => group.name);
    });
    this.apiService.getDevicesOffline().subscribe((data) => {
      this.offlineTotal = data.offline;
    });
    // Listen for changes to filterValue, apply debounce on the API call
    this.filterSubject
      .pipe(
        debounceTime(300), // Debounce time in ms
        switchMap(([filterValue, currentPage]) => {
          let filters: any = {};
          if (filterValue) {
            filters[this.selectedColumn] = filterValue;
          }
          return this.apiService.getDevices(currentPage, filters); // API call with filters
        })
      )
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data.devices); // Update table data
        this.offline = data.offline; // Update offline count
      });

    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabSelected'] && changes['tabSelected'].currentValue) {
      this.filterSubject.next([this.filterValue, this.currentPage]);
      this.apiService.getGroups(1, {}).subscribe((data) => {
        this.groups = data.map((group: { name: string }) => group.name);
      });
    }
  }

  // Trigger the filter change and emit the new value to filterSubject
  onFilterChange() {
    this.currentPage = 1; // Reset to the first page when filter changes
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  onGroupChange(mac: string, group: string) {
    this.apiService.changeGroupDevice(mac, group).subscribe((data) => {});
  }

  onNext() {
    if (this.dataSource.data.length === 0) {
      return;
    }
    this.currentPage++;
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  onPrev() {
    if (this.currentPage <= 1) {
      return;
    }
    this.currentPage--;
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }
}
